import SupportAlert, { displayAlert, displayConfirmationAlert } from './SupportAlert';

export default { SupportAlert, displayAlert, displayConfirmationAlert }